import styled from 'styled-components';

const WidgetFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
`;

export default WidgetFooter;
